// Static, env-driven landing-page content — same code across every
// storefront/<client>/ deployment, just a different .env per client. Every
// field is independently optional: leaving one unset simply hides that
// section on LandingPage.jsx, nothing else changes. Baked in at build time
// (CRA), same as REACT_APP_SELLER_ID/REACT_APP_API_URL in webOrderApi.js —
// a value change on the server requires `npm run build` again, not just an
// env edit.
const landingConfig = {
  // Path to a logo file placed directly in this app's public/ folder on the
  // server (e.g. "/logo-madhavvadapav.png") — CRA serves public/ at the site
  // root, so no import/bundling is needed for it. Rendered as-is (no forced
  // circular crop/border) — a transparent PNG shows through however its own
  // artwork is shaped.
  logoUrl: process.env.REACT_APP_STORE_LOGO_URL || null,

  // Folded into the page heading: "Welcome to {name}".
  storeName: process.env.REACT_APP_STORE_NAME || null,

  // Single contact number — "Contact : {phone}".
  phone: process.env.REACT_APP_STORE_PHONE || null,

  // Short paragraph shown under the heading (e.g. what makes the store's
  // products special). Plain text, no formatting.
  description: process.env.REACT_APP_STORE_DESCRIPTION || null,

  // External review-page link (e.g. the store's Google Maps listing) for
  // the "GOOGLE REVIEWS" button — button only renders when this is set.
  googleReviewUrl: process.env.REACT_APP_STORE_GOOGLE_REVIEW_URL || null,

  // Free-text address shown on the "Visit Us" button (e.g. "1, Ground
  // Floor, Shilp Aaron, ..."). Independent of mapLat/mapLng below — this is
  // display-only, never used to build the Maps link itself.
  address: process.env.REACT_APP_STORE_ADDRESS || null,

  // Plain decimal latitude/longitude — used only to build the "Visit Us"
  // button's Google Maps link (no API key/billing account needed for a
  // plain maps.google.com search/query URL). If unset but `address` is,
  // the Maps link falls back to searching by the address text instead —
  // see LandingPage.jsx's mapsUrl.
  mapLat: process.env.REACT_APP_STORE_MAP_LAT || null,
  mapLng: process.env.REACT_APP_STORE_MAP_LNG || null,

  social: {
    facebook: process.env.REACT_APP_STORE_FACEBOOK_URL || null,
    instagram: process.env.REACT_APP_STORE_INSTAGRAM_URL || null,
    youtube: process.env.REACT_APP_STORE_YOUTUBE_URL || null,
  },

  // Page background color — a plain hex/CSS color, so each store can look
  // distinct without touching tailwind.config.js (which only themes the
  // rest of this app's own brand-* classes, not this page specifically).
  // Falls back to a warm cream tint sampled from the Madhav Vada Pav logo
  // (matches tailwind.config.js's brand-50) rather than the generic
  // neutral-gray default other storefronts fall back to, so the Landing
  // Page still looks on-brand even before a seller sets this explicitly.
  themeColor: process.env.REACT_APP_STORE_THEME_COLOR || "#FDF6EC",

  // Heading/button-outline/button-text/icon color — the page's one accent
  // color, paired against themeColor above. Falls back to the same true
  // black sampled from the logo's badge background (matches
  // tailwind.config.js's brand-950) instead of the generic neutral-black
  // default other storefronts fall back to.
  accentColor: process.env.REACT_APP_STORE_ACCENT_COLOR || "#121211",
};

export default landingConfig;
